// extracted by mini-css-extract-plugin
module.exports = {"input":"Search_input__1Psin"};